/* eslint-disable @typescript-eslint/naming-convention */
import { Extension } from '@tiptap/core';

const DisableAllShortcuts = Extension.create({
  name: 'disableAllShortcuts',

  addKeyboardShortcuts() {
    return {
      // Disable all shortcuts from https://tiptap.dev/docs/editor/api/keyboard-shortcuts
      // Text Formatting
      'Mod-b': () => true,
      'Mod-i': () => true,
      'Mod-u': () => true,
      'Mod-shift-x': () => true,
      'Mod-shift-h': () => true,
      'Mod-e': () => true,
      // Paragraph formatting
      'Mod-alt-0': () => true,
      'Mod-alt-1': () => true,
      'Mod-alt-2': () => true,
      'Mod-alt-3': () => true,
      'Mod-alt-4': () => true,
      'Mod-alt-5': () => true,
      'Mod-alt-6': () => true,
      'Mod-shift-7': () => true,
      'Mod-shift-8': () => true,
      'Mod-shift-9': () => true,
      'Mod-shift-b': () => true,
      'Mod-shift-l': () => true,
      'Mod-shift-e': () => true,
      'Mod-shift-r': () => true,
      'Mod-shift-j': () => true,
      'Mod-alt-c': () => true,
      'Mod-,': () => true,
      'Mod-.': () => true,
      // Remove double \n
      Enter: ({ editor }) => editor.commands.keyboardShortcut('shift-Enter'),
    };
  },
});

export default DisableAllShortcuts;
